<template>
  <!-- 渠道绑定半层：通过 transition 实现从底部滑出/滑入的过渡动画 -->
  <transition name="cbs">
    <div v-if="visible" class="cbs-mask" @click="$emit('close')">
      <div class="cbs-sheet" @click.stop>
        <div class="cbs-header">
          <p class="cbs-title">{{ channelName }}</p>
          <span class="cbs-close" @click="$emit('close')"></span>
        </div>

      <div class="cbs-body hide-scrollbar" @focusin="onFieldFocus" @focusout="onBodyFocusOut">
        <!-- GPay -->
        <template v-if="isGpay">
          <div class="cbs-field">
            <label>{{ detailsObj.userFullName }}</label>
            <input
              v-model="gPayInfo.accountName"
              type="text"
              :placeholder="detailsObj.userFullNameInfo"
              maxlength="30"
            />
          </div>
          <div class="cbs-field">
            <label>{{ detailsObj.bank }}</label>
            <div class="cbs-select" @click="menuFlag = menuFlag === 1 ? 0 : 1">
              {{ gPayBankName || detailsObj.select }}
            </div>
            <div v-if="menuFlag === 1" class="cbs-bank-menu">
              <input v-model="banName" type="text" :placeholder="detailsObj.bankName" @click.stop />
              <p v-for="bank in filteredBankList" :key="bank.code" @click="changeBank(bank)">
                {{ bank.name }}
              </p>
            </div>
          </div>
          <div class="cbs-field">
            <label>{{ detailsObj.iban }}</label>
            <input
              v-model="gPayInfo.iban"
              type="text"
              :placeholder="detailsObj.ibanInfo"
              maxlength="40"
            />
          </div>
          <div class="cbs-field">
            <label>{{ detailsObj.whatsAppMessage }}<i class="req">*</i></label>
            <input v-model="whatsApp" type="text" :placeholder="detailsObj.whatsAppTip2" />
            <p v-if="whatsAppError" class="cbs-error">{{ whatsAppError }}</p>
          </div>
          <p v-if="gPayError" class="cbs-error">{{ gPayError }}</p>
        </template>

        <!-- 土耳其 -->
        <template v-else-if="isTr">
          <div class="cbs-field">
            <label>{{ detailsObj.pmnameMessage }}</label>
            <input v-model="payeeName" type="text" />
            <p v-if="trNameError" class="cbs-error">{{ trNameError }}</p>
          </div>
          <div class="cbs-field">
            <label>{{ detailsObj.pmaccountMessage }}</label>
            <input v-model="payeeAccount" type="text" @input="sanitizeAccount" />
            <p v-if="trAccountError" class="cbs-error">{{ trAccountError }}</p>
          </div>
          <div class="cbs-field">
            <label>{{ detailsObj.whatsAppMessage }}<i class="req">*</i></label>
            <input v-model="whatsApp" type="text" />
            <p v-if="whatsAppError" class="cbs-error">{{ whatsAppError }}</p>
          </div>
        </template>

        <!-- PIX -->
        <template v-else-if="isPix">
          <!-- Pix username：必填 -->
          <div class="cbs-field">
            <label>{{ $t("withdrawalLogin.name") }}<i class="req">*</i></label>
            <input
              v-model="pixName"
              type="text"
              :class="{ 'is-error': !!pixNameError }"
              :placeholder="$t('pixNamePlaceholder')"
            />
            <p v-if="pixNameError" class="cbs-error">{{ pixNameError }}</p>
          </div>
          <!-- ID type：必填下拉，选中后展示 Personal ID number 输入框 -->
          <div class="cbs-field">
            <label>{{ $t("pixIdType") }}<i class="req">*</i></label>
            <div class="cbs-select" :class="{ 'is-error': !!documentTypeError }" @click="toggleDocMenu">
              <span class="cbs-select-text">{{ documentType || $t('pixSelectIdTypePlaceholder') }}</span>
              <i class="cbs-select-arrow" :class="{ 'is-up': docMenuFlag }"></i>
            </div>
            <div v-if="docMenuFlag" class="cbs-option-menu">
              <p
                v-for="opt in documentTypes"
                :key="opt"
                :class="['cbs-option', { 'is-active': documentType === opt }]"
                @click="selectDocumentType(opt)"
              >
                {{ opt }}
              </p>
            </div>
          </div>
          <!-- Personal ID number：仅选中 ID type 后展示；提示文字取对应类型 -->
          <div v-if="documentType" class="cbs-field">
            <!-- <label>{{ $t("withdrawalLogin.documentId") }}<i class="req">*</i></label> -->
            <input
              ref="pixDocumentInput"
              v-model="documentId"
              type="text"
              inputmode="numeric"
              @input="sanitizeDocumentId"
              :class="{ 'is-error': !!documentIdError }"
              :placeholder="$t('pixIdPlaceholder', { s: documentType })"
            />
            <p v-if="documentIdError" class="cbs-error">{{ documentIdError }}</p>
          </div>
          <!-- Pix account type：必填下拉，选中后展示 Pix account ID 输入框 -->
          <div class="cbs-field">
            <label>{{ $t("withdrawalLogin.accountType") }}<i class="req">*</i></label>
            <div class="cbs-select" :class="{ 'is-error': !!accountTypeError }" @click="toggleAccMenu">
              <span class="cbs-select-text">{{ accountType || $t('pixSelectAccountTypePlaceholder') }}</span>
              <i class="cbs-select-arrow" :class="{ 'is-up': accMenuFlag }"></i>
            </div>
            <div v-if="accMenuFlag" class="cbs-option-menu hide-scrollbar">
              <p
                v-for="opt in accountTypes"
                :key="opt"
                :class="['cbs-option', { 'is-active': accountType === opt }]"
                @click="selectAccountType(opt)"
              >
                {{ opt }}
              </p>
            </div>
          </div>
          <!-- Pix account ID：仅选中 account type 后展示；提示文字取对应类型 -->
          <div v-if="accountType" class="cbs-field">
            <!-- <label>{{ $t("withdrawalLogin.accountId") }}<i class="req">*</i></label> -->
            <!-- PHONE 类型：账号前缀固定展示国家码 +55（写死，不可编辑） -->
            <div v-if="accountType === 'PHONE'" class="cbs-input-group">
              <span class="cbs-prefix">+55</span>
              <input
                ref="pixAccountInput"
                v-model="pixAccount"
                type="text"
                inputmode="numeric"
                @input="sanitizePixAccount"
                :class="{ 'is-error': !!pixAccountError }"
                :placeholder="$t('pixAccountPlaceholder', { s: accountType })"
              />
            </div>
            <input
              v-else
              ref="pixAccountInput"
              v-model="pixAccount"
              type="text"
              :inputmode="isPixNumericAccount ? 'numeric' : 'text'"
              @input="sanitizePixAccount"
              :class="{ 'is-error': !!pixAccountError }"
              :placeholder="$t('pixAccountPlaceholder', { s: accountType })"
            />
            <p v-if="pixAccountError" class="cbs-error">{{ pixAccountError }}</p>
          </div>
          <!-- WhatsApp ID：必填，标题固定为 WhatsApp ID -->
          <div class="cbs-field">
            <label>{{ detailsObj.whatsAppMessage || 'WhatsApp ID' }}<i class="req">*</i></label>
            <input
              v-model="whatsApp"
              type="text"
              :class="{ 'is-error': !!whatsAppError }"
              :placeholder="$t('whatsAppIdPlaceholder')"
            />
            <p v-if="whatsAppError" class="cbs-error">{{ whatsAppError }}</p>
          </div>
        </template>

        <!-- 印尼钱包 18-22 -->
        <template v-else-if="isIndonesiaWallet">
          <div class="cbs-field">
            <label>{{ detailsObj.pmnameTip || detailsObj.pmnameMessage }}</label>
            <input
              v-model="fullName"
              type="text"
              :placeholder="detailsObj.pmnameMessage"
            />
            <p v-if="fullNameError" class="cbs-error">{{ fullNameError }}</p>
          </div>
          <div class="cbs-field">
            <label>{{ detailsObj.pmaccountTip || detailsObj.pmaccountMessage }}</label>
            <input
              v-model="payeeAccount"
              type="text"
              :placeholder="detailsObj.pmaccountMessage"
            />
            <p v-if="payeeAccountError" class="cbs-error">{{ payeeAccountError }}</p>
          </div>
          <div class="cbs-field">
            <label>{{ detailsObj.whatsAppMessage }}<i class="req">*</i></label>
            <input v-model="whatsApp" type="text" :placeholder="detailsObj.whatsAppTip2" />
            <p v-if="whatsAppError" class="cbs-error">{{ whatsAppError }}</p>
          </div>
        </template>

        <!-- 印尼银行 15 / 电子钱包 16 -->
        <template v-else-if="isIndonesiaBank || isIndonesiaEwallet">
          <div class="cbs-field">
            <label>{{ detailsObj.pnidMessage }}</label>
            <input v-model="fullName" type="text" :placeholder="detailsObj.pnidTip" />
            <p v-if="fullNameError" class="cbs-error">{{ fullNameError }}</p>
          </div>
          <div class="cbs-field">
            <label>{{ detailsObj.bank }}</label>
            <div class="cbs-select" @click="menuFlag = menuFlag === 1 ? 0 : 1">
              {{ bankName || detailsObj.select || detailsObj.bankTips }}
            </div>
            <div v-if="menuFlag === 1" class="cbs-bank-menu">
              <input v-model="banName" type="text" :placeholder="detailsObj.bankTips" @click.stop />
              <p v-for="bank in filteredBankList" :key="bank.code" @click="changeIndonesiaBank(bank)">
                {{ bank.name }}
              </p>
            </div>
            <p v-if="bankError" class="cbs-error">{{ bankError }}</p>
          </div>
          <div v-if="isIndonesiaBank" class="cbs-field">
            <label>{{ detailsObj.bankCardNumber }}</label>
            <input v-model="cardNumber" type="text" :placeholder="detailsObj.bankCardNumber" />
            <p v-if="cardNumberError" class="cbs-error">{{ cardNumberError }}</p>
          </div>
          <div v-else class="cbs-field">
            <label>{{ detailsObj.bankCardNumber }}</label>
            <input v-model="phoneNumber" type="text" :placeholder="detailsObj.bankCardNumber" />
            <p v-if="phoneNumberError" class="cbs-error">{{ phoneNumberError }}</p>
          </div>
          <div class="cbs-field">
            <label>{{ detailsObj.whatsAppMessage }}<i class="req">*</i></label>
            <input v-model="whatsApp" type="text" :placeholder="detailsObj.whatsAppTip2" />
            <p v-if="whatsAppError" class="cbs-error">{{ whatsAppError }}</p>
          </div>
        </template>

        <!-- 标准渠道 -->
        <template v-else>
          <!-- 姓名：仅渠道有姓名字段(pmnameMessage)时才展示，避免无姓名渠道 label 撞车(重复) -->
          <div v-if="detailsObj.pmnameMessage" class="cbs-field">
            <label>{{ detailsObj.pmnameMessage }}</label>
            <input v-model="payeeName" type="text" :placeholder="$t('guild_please_enter')" />
          </div>
          <div class="cbs-field">
            <label>{{ accountLabel }}<i class="req">*</i></label>
            <input
              v-model="account"
              type="text"
              :maxlength="accountMaxLength"
              @blur="validateAccount"
            />
            <p v-if="accountError" class="cbs-error">{{ accountError }}</p>
          </div>
          <div class="cbs-field">
            <label>{{ detailsObj.whatsAppMessage }}<i class="req">*</i></label>
            <input v-model="whatsApp" type="text" :placeholder="detailsObj.whatsAppTip2" />
          </div>
        </template>

        <div class="cbs-tips">
          <p class="cbs-tips-title">{{ $t("guild_bind_notice_title") }}</p>
          <!-- <p>1. {{ $t("guild_bind_tip_1") }}</p> -->
          <p>{{ $t("guild_bind_tip_2") }}</p>
        </div>
      </div>

      <div class="cbs-footer">
        <button type="button" class="cbs-submit" :disabled="submitting" @click="submitBind">
          {{ $t("guild_confirm_bind") }}
        </button>
      </div><!-- /cbs-footer -->
    </div><!-- /cbs-sheet -->
  </div><!-- /cbs-mask -->
</transition>
</template>

<script>
/**
 * 渠道绑定半层（2026-06-08）
 *
 * 替代旧页 withdrawalDetails / indonesia / pixDetails 的表单填写环节。
 * 提交 api/trade/card/tx/bindInfo/save（bindType=1），字段由 buildBindParams 组装。
 *
 * 表单分支：GPay(11) / 土耳其(4) / PIX(9,10) / 印尼钱包(18-22) / 印尼银行(15) / 印尼电子钱包(16) / 标准
 * 校验规则对齐旧 withdrawalDetails.validateInput* 与 indonesia.vue 各 validate* 方法
 */
import { Toast } from "vant";
import keepFocusedInputVisible from "@/mixins/keepFocusedInputVisible";
import {
  isGpayChannel,
  isTrChannel,
  isPixChannel,
  isIndonesiaWalletChannel,
  isIndonesiaBankChannel,
  isIndonesiaEwalletChannel,
  buildBindParams,
} from "@/utils/withdrawChannel";
import {
  BIND_TYPE_WITHDRAW,
  saveBindInfo,
  loadBindInfo,
} from "@/utils/bindInfo";

export default {
  name: "channel-bind-sheet",
  mixins: [keepFocusedInputVisible],
  keyboardAvoidance: {
    maskSelector: ".cbs-mask",
    sheetSelector: ".cbs-sheet",
    scrollSelector: ".cbs-body",
    margin: 16,
  },
  props: {
    visible: { type: Boolean, default: false },
    channelName: { type: String, default: "" },
    detailsObj: { type: Object, default: () => ({}) },
    itemId: { type: [Number, String], default: 0 },
    sabankList: { type: Array, default: () => [] },
    token: { type: String, default: "" },
    uid: { type: String, default: "" },
    deviceId: { type: String, default: "" },
    lang: { type: String, default: "" },
  },
  data() {
    return {
      submitting: false,
      account: "",
      payeeName: "",
      payeeAccount: "",
      whatsApp: "",
      accountError: "",
      fullNameError: "",
      payeeAccountError: "",
      cardNumberError: "",
      phoneNumberError: "",
      whatsAppError: "",
      pixNameError: "",
      // PIX 证件类型下拉错误标记（非空则标红）
      documentTypeError: "",
      documentIdError: "",
      // PIX 账户类型下拉错误标记（非空则标红）
      accountTypeError: "",
      pixAccountError: "",
      trNameError: "",
      trAccountError: "",
      gPayError: "",
      bankError: "",
      fullName: "",
      cardNumber: "",
      phoneNumber: "",
      bankName: "",
      bankId: "",
      pixName: "",
      // 证件类型：默认空（未选择时不展示 Personal ID number 输入框）
      documentType: "",
      documentId: "",
      // 账户类型：默认空（未选择时不展示 Pix account ID 输入框）
      accountType: "",
      pixAccount: "",
      // PIX 证件类型选项列表（CPF / CNPJ）
      documentTypes: ["CPF", "CNPJ"],
      // PIX 账户类型选项列表
      accountTypes: ["CPF", "CNPJ", "PHONE", "EMAIL", "EVP"],
      // 证件类型下拉展开标记
      docMenuFlag: false,
      // 账户类型下拉展开标记
      accMenuFlag: false,
      gPayInfo: {
        accountName: "",
        iban: "",
        bankId: "",
        branchNumber: "111111",
        accountNumber: "111111",
        type: "ACCOUNT",
      },
      gPayBankName: "",
      menuFlag: 0,
      banName: "",
    };
  },
  computed: {
    // 是否为 GPay 渠道（通过 itemId 判断渠道类型）
    isGpay() {
      return isGpayChannel(this.itemId);
    },
    // 是否为土耳其渠道
    isTr() {
      return isTrChannel(this.itemId);
    },
    // 是否为 PIX 渠道
    isPix() {
      return isPixChannel(this.itemId);
    },
    // 是否为印尼钱包渠道
    isIndonesiaWallet() {
      return isIndonesiaWalletChannel(this.itemId);
    },
    // 是否为印尼银行渠道
    isIndonesiaBank() {
      return isIndonesiaBankChannel(this.itemId);
    },
    // 是否为印尼电子钱包渠道
    isIndonesiaEwallet() {
      return isIndonesiaEwalletChannel(this.itemId);
    },
    // 收款人姓名字段文案：优先用后端消息，否则取默认文案
    nameLabel() {
      // 仅渠道有姓名提示时返回，避免无姓名渠道回退到账号文案(pnidMessage)导致两输入框 label 相同
      return this.detailsObj.pmnameMessage || "";
    },
    // 收款账号字段文案：优先用后端消息，否则取默认文案
    accountLabel() {
      return this.detailsObj.pnidMessage || this.detailsObj.pmaccountMessage || this.$t("guild_bank_account");
    },
    // 账号最大长度：PIX 渠道固定 10，其余不限
    accountMaxLength() {
      if (Number(this.itemId) === 8) return 10;
      return 999;
    },
    // PIX 账号类型是否为纯数字型（CPF/CNPJ/PHONE），用于决定是否弹起数字键盘
    isPixNumericAccount() {
      const t = this.accountType;
      return t === "CPF" || t === "CNPJ" || t === "PHONE";
    },
    // 银行列表按输入关键字实时过滤（不区分大小写）
    filteredBankList() {
      const q = this.banName.toLowerCase();
      if (!q) return this.sabankList;
      return this.sabankList.filter((item) =>
        item.name.toLowerCase().includes(q)
      );
    },
  },
  watch: {
    // 半层显示时：先尝试用服务端已保存信息回填，再兜底本地/接口字段
    visible(val) {
      if (val) {
        this.loadServerBindInfo();
      }
    },
    // 绑定详情变化时（如外部传入）自动回填表单
    detailsObj: {
      handler() {
        if (this.visible) this.fillFromDetails();
      },
      deep: true,
    },
  },
  methods: {
    // 打开半层时先用服务端 bindInfo 已保存信息回填，再兜底 initForWeb infos / 旧 localStorage
    loadServerBindInfo() {
      loadBindInfo({
        bindType: BIND_TYPE_WITHDRAW,
        bizKey: String(this.itemId),
        serviceIp: this.$serviceIp,
        token: this.token,
        uid: this.uid,
        deviceId: this.deviceId,
        lang: this.lang,
      }).then((serverData) => {
        // serverData 为 BindInfoVO，绑定字段在 infoJson 中；无则走接口/localStorage 兜底
        this.fillFromDetails((serverData && serverData.infoJson) || null);
      });
    },
    // 打开半层时用已保存的信息回填表单；serverData 来自服务端 bindInfo（优先级最高）
    fillFromDetails(serverData = null) {
      const d = this.detailsObj || {};
      const id = Number(this.itemId);
      // 通用取字段：优先服务端存储，其次接口 infos，最后旧 localStorage
      const pick = (serverKey, ...fallbacks) => {
        if (serverData && serverData[serverKey] != null) return serverData[serverKey];
        for (const key of fallbacks) {
          const v = d[key];
          if (v != null && v !== "") return v;
        }
        return "";
      };
      // WhatsApp 通用回填
      this.whatsApp =
        pick("whatsApp", "savedWhatsApp", "whatsApp", "displayWhatsApp") ||
        localStorage.getItem("id") ||
        localStorage.getItem("whatsApp") ||
        "";

      if (this.isGpay) {
        // GPay：账户名 / IBAN / 银行 id 与名称，仅回填服务端已保存绑定信息，不兜底渠道 infos
        this.gPayInfo.accountName = (serverData && serverData.accountName) || "";
        this.gPayInfo.iban = (serverData && serverData.iban) || "";
        this.gPayInfo.bankId = (serverData && serverData.bankId) || "";
        this.gPayBankName = (serverData && serverData.bankName) || "";
        return;
      }
      if (this.isTr) {
        // 土耳其：收款人姓名 + 账号
        this.payeeName = pick("payeeName", "savedPayeeName", "payeeName");
        this.payeeAccount = pick("payeeAccount", "savedPayeeAccount", "payeeAccount");
        return;
      }
      if (this.isPix) {
        // PIX：姓名 / 证件类型与编号 / 账户类型与编号
        // 证件/账户类型无兜底值，保持空（未选择时不展示对应输入框）
        this.pixName = pick("name", "savedName", "name") || localStorage.getItem("name") || "";
        this.documentType = pick("document_type", "savedDocumentType", "document_type") || localStorage.getItem("document_type") || "";
        this.documentId = pick("document_id", "savedDocumentId", "document_id") || localStorage.getItem("document_id") || "";
        this.accountType = pick("account_type", "savedAccountType", "account_type") || localStorage.getItem("account_type") || "";
        let savedAccount = pick("account", "savedAccount", "account") || localStorage.getItem("account") || "";
        // PHONE 类型回填时去掉写死的国家码前缀 +55，避免重复展示
        if (this.accountType === "PHONE" && savedAccount.indexOf("+55") === 0) {
          savedAccount = savedAccount.slice(3);
        }
        this.pixAccount = savedAccount;
        return;
      }
      if (this.isIndonesiaWallet) {
        // 印尼钱包：姓名 + 账号
        this.fullName =
          pick("payeeName", "savedPayeeName", "payeeName", "savedFullName", "fullName") ||
          localStorage.getItem("fullName") ||
          "";
        this.payeeAccount = pick("payeeAccount", "savedPayeeAccount", "payeeAccount") || localStorage.getItem("payeeAccount") || "";
        return;
      }
      if (this.isIndonesiaBank || this.isIndonesiaEwallet) {
        // 印尼银行/电子钱包聚合：姓名 / 银行 / 卡号或手机号
        this.fullName = pick("account", "savedFullName", "fullName", "account") || localStorage.getItem("fullName") || "";
        this.bankId = pick("account_bank_code", "bankId", "savedBankId", "bankId", "account_bank_code");
        this.bankName = pick("bankName", "savedBankName", "bankName");
        this.cardNumber = pick("account_number", "cardNumber", "savedCardNumber", "cardNumber", "account_number") || localStorage.getItem("cardNumber") || "";
        this.phoneNumber = pick("account_phone", "phoneNumber", "savedPhoneNumber", "phoneNumber", "account_phone") || localStorage.getItem("phoneNumber") || "";
        return;
      }

      // 标准渠道：姓名 + 账号（兼容旧缓存 num{id}）
      this.payeeName = pick("payeeName", "savedFullName", "fullName", "payeeName");
      this.account =
        pick("account", "savedPayeeAccount", "payeeAccount", "account") ||
        localStorage.getItem("num" + id) ||
        "";
    },
    // 展开/收起 PIX 证件类型下拉（同时收起账户类型下拉，避免重叠）
    toggleDocMenu() {
      this.dismissKeyboard();
      this.docMenuFlag = !this.docMenuFlag;
      if (this.docMenuFlag) this.accMenuFlag = false;
    },
    // 展开/收起 PIX 账户类型下拉（同时收起证件类型下拉，避免重叠）
    toggleAccMenu() {
      this.dismissKeyboard();
      this.accMenuFlag = !this.accMenuFlag;
      if (this.accMenuFlag) this.docMenuFlag = false;
    },
    // 选择 PIX 证件类型：赋值并收起下拉；保留已填证件号，清空校验提示（切换后重新校验）
    selectDocumentType(opt) {
      this.documentType = opt;
      this.docMenuFlag = false;
      this.documentIdError = "";
    },
    // 选择 PIX 账户类型：赋值并收起下拉；保留已填账户ID，清空校验提示（切换后重新校验）
    selectAccountType(opt) {
      this.accountType = opt;
      this.accMenuFlag = false;
      this.pixAccountError = "";
    },
    // 选择 GPay 银行：记录银行名称与编码并收起银行选择列表
    changeBank(item) {
      this.gPayBankName = item.name;
      this.gPayInfo.bankId = item.code;
      this.menuFlag = 0;
    },
    // 选择印尼银行：记录银行名称与编码并收起银行选择列表
    changeIndonesiaBank(item) {
      this.bankName = item.name;
      this.bankId = item.code;
      this.menuFlag = 0;
    },
    // 清洗收款账号：仅保留字母数字与 . / 字符
    sanitizeAccount() {
      this.payeeAccount = this.payeeAccount.replace(/[^\w./]/gi, "");
    },
    // PIX 证件号：仅保留数字
    sanitizeDocumentId() {
      this.documentId = String(this.documentId).replace(/\D/g, "");
    },
    // PIX 账号：纯数字类型(CPF/CNPJ/PHONE)仅保留数字；EMAIL/EVP 不限制
    sanitizePixAccount() {
      if (this.isPixNumericAccount) {
        this.pixAccount = String(this.pixAccount).replace(/\D/g, "");
      }
    },
    // 清空所有渠道的字段错误提示
    clearFieldErrors() {
      this.accountError = "";
      this.fullNameError = "";
      this.payeeAccountError = "";
      this.cardNumberError = "";
      this.phoneNumberError = "";
      this.whatsAppError = "";
      this.pixNameError = "";
      this.documentTypeError = "";
      this.documentIdError = "";
      this.accountTypeError = "";
      this.pixAccountError = "";
      this.trNameError = "";
      this.trAccountError = "";
      this.gPayError = "";
      this.bankError = "";
    },
    // 标准渠道账号校验：按渠道 id 应用不同格式规则
    validateAccount() {
      const id = Number(this.itemId);
      const val = this.account.trim();
      // 账号必填
      if (!val) {
        this.accountError = this.$t("withdrawalLogin.incorrectAccount");
        return false;
      }
      // 5 Vodafone Cash：11 位且以 01 开头（旧 validateInputVodafoneCasht）
      if (id === 5) {
        if (val.length !== 11 || !val.startsWith("01")) {
          this.accountError = this.$t("withdrawalLogin.incorrectAccount");
          return false;
        }
      } else if (id === 6) {
        // 6 Payoneer：邮箱（旧 validateInputPayoneerAccount）
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        if (!emailRegex.test(val)) {
          this.accountError = this.$t("withdrawalLogin.incorrectAccount");
          return false;
        }
      } else if (id === 8) {
        // 8 Papara：纯数字最多 10 位
        if (!/^\d+$/.test(val) || val.length > 10) {
          this.accountError = this.$t("withdrawalLogin.incorrectAccount");
          return false;
        }
      } else if (id === 12) {
        // 12 PayPal：邮箱或 1-30 位手机号（旧 validateInputPaypalAccount）
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        const phoneRegex = /^\d{1,30}$/;
        if (!emailRegex.test(val) && !phoneRegex.test(val)) {
          this.accountError = this.$t("withdrawalLogin.incorrectAccount");
          return false;
        }
      } else if (id === 13 || id === 17) {
        // 13/17 TRC20/BEP20 地址（旧 validateInputTrc20）
        const trcRegex = /^T[a-zA-Z1-9]{33}$/;
        const bepRegex = /^0x[a-fA-F0-9]{40}$/;
        if (!trcRegex.test(val) && !bepRegex.test(val)) {
          this.accountError = this.$t("withdrawalLogin.incorrectAccount");
          return false;
        }
      }
      this.accountError = "";
      return true;
    },
    // 判断字符串是否包含 Emoji 字符
    containsEmoji(str) {
      const emojiRegex = /(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])/u;
      return emojiRegex.test(str);
    },
    // 印尼姓名校验：英文姓名（含空格/连字符/撇号）、禁 emoji、长度≤100
    validateIndonesiaName() {
      // 对齐 indonesia.vue validateName：英文姓名、禁 emoji
      const value = this.fullName.trim();
      const nameMsg = this.isIndonesiaWallet
        ? this.detailsObj.pmnameMessage
        : this.detailsObj.pnidMessage;
      // 空值、超长或含 emoji 均不通过
      if (!value || value.length > 100 || this.containsEmoji(value)) {
        this.fullNameError = nameMsg;
        return false;
      }
      const englishOnlyRegex = /^[a-zA-Z\s\-']+$/;
      if (!englishOnlyRegex.test(value)) {
        this.fullNameError = nameMsg;
        return false;
      }
      this.fullNameError = "";
      return true;
    },
    // 印尼钱包账号校验：数字/连字符且必须以 08 开头
    validateIndonesiaWalletAccount() {
      // 对齐 indonesia.vue validatePayeeAccount：08 开头
      const value = this.payeeAccount.trim();
      if (!value) {
        this.payeeAccountError = this.detailsObj.pmaccountMessage;
        return false;
      }
      if (!/^[\d-]+$/.test(value) || !value.startsWith("08")) {
        this.payeeAccountError = this.detailsObj.pmaccountMessage;
        return false;
      }
      this.payeeAccountError = "";
      return true;
    },
    // 印尼银行卡号校验：必填且为纯数字
    validateIndonesiaCardNumber() {
      const value = this.cardNumber.trim();
      if (!value || !/^\d+$/.test(value)) {
        this.cardNumberError = this.detailsObj.bankCardNumber;
        return false;
      }
      this.cardNumberError = "";
      return true;
    },
    // 印尼手机号校验：纯数字且长度≤30
    validateIndonesiaPhone() {
      const value = this.phoneNumber.trim();
      if (!value || !/^\d+$/.test(value) || value.length > 30) {
        this.phoneNumberError = this.detailsObj.bankCardNumber;
        return false;
      }
      this.phoneNumberError = "";
      return true;
    },
    // WhatsApp 校验：纯数字且长度≤30（多渠道共用）
    validateWhatsAppDigits() {
      const value = String(this.whatsApp || "").trim();
      if (!value || !/^\d+$/.test(value) || value.length > 30) {
        this.whatsAppError = this.detailsObj.whatsAppMessage || this.$t("withdrawalLogin.Whatsapp");
        return false;
      }
      this.whatsAppError = "";
      return true;
    },
    // GPay 渠道表单校验：账户名/银行/IBAN/WhatsApp 均必填
    validateGpayForm() {
      // 对齐 withdrawalDetails gPayInfoAll 提示文案
      if (!this.gPayInfo.accountName) {
        this.gPayError = this.detailsObj.userFullNameInfo;
        return false;
      }
      if (!this.gPayInfo.bankId) {
        this.gPayError = (this.detailsObj.select || "") + (this.detailsObj.bank || "");
        return false;
      }
      if (!this.gPayInfo.iban) {
        this.gPayError = this.detailsObj.ibanInfo;
        return false;
      }
      if (!this.whatsApp) {
        this.gPayError = this.detailsObj.whatsAppTip;
        return false;
      }
      this.gPayError = "";
      return true;
    },
    // 土耳其渠道表单校验：账号/姓名(≥5)/WhatsApp 均必填
    validateTrForm() {
      // 对齐 withdrawalDetails submitTr
      if (!this.payeeAccount) {
        this.trAccountError = this.detailsObj.pmaccountTip;
        return false;
      }
      if (!this.payeeName || this.payeeName.length < 5) {
        this.trNameError = this.detailsObj.pmnameTip;
        return false;
      }
      if (!this.whatsApp) {
        this.whatsAppError = this.$t("withdrawalLogin.Whatsapp");
        return false;
      }
      this.trNameError = "";
      this.trAccountError = "";
      this.whatsAppError = "";
      return true;
    },
    // 校验证件号（Personal ID number）：CPF 必须 11 位数字，CNPJ 必须 14 位数字
    // 返回错误文案；校验通过返回空串
    validatePixDocumentId(type) {
      if (!this.documentId) {
        return this.$t("withdrawalLogin.documentIdtsa");
      }
      // 仅能输入数字（清洗掉非数字）
      const num = this.documentId.replace(/\D/g, "");
      // CPF：最多 11 位数字，且必须为 11 位
      if (type === "CPF") {
        if (num.length !== 11) {
          return this.$t("pixCpfLengthError");
        }
        return "";
      }
      // CNPJ：最多 14 位数字，且必须为 14 位
      if (type === "CNPJ") {
        if (num.length !== 14) {
          return this.$t("pixCnpjLengthError");
        }
        return "";
      }
      return "";
    },
    // 校验 Pix account ID：按所选 accountType 规则校验
    // 返回错误文案；校验通过返回空串
    validatePixAccountId() {
      if (!this.pixAccount) {
        return this.$t("withdrawalLogin.accountIdtsa");
      }
      const value = this.pixAccount;
      const type = this.accountType;
      // 仅数字类型（CPF/CNPJ/PHONE）先清洗为纯数字
      const num = value.replace(/\D/g, "");
      // CPF：仅数字、最多 11 位、必须 11 位
      if (type === "CPF") {
        if (num.length !== 11) {
          return this.$t("pixCpfLengthError");
        }
        // 若 ID type 也是 CPF，则两处填写的值应保持一致
        if (this.documentType === "CPF" && this.documentId && this.documentId.replace(/\D/g, "") !== num) {
          return this.$t("pixCpfNotMatchError");
        }
        return "";
      }
      // CNPJ：仅数字、最多 14 位、必须 14 位
      if (type === "CNPJ") {
        if (num.length !== 14) {
          return this.$t("pixCnpjLengthError");
        }
        // 若 ID type 也是 CNPJ，则两处填写的值应保持一致
        if (this.documentType === "CNPJ" && this.documentId && this.documentId.replace(/\D/g, "") !== num) {
          return this.$t("pixCnpjNotMatchError");
        }
        return "";
      }
      // Phone：仅数字、最少 9 位、最多 11 位
      if (type === "PHONE") {
        if (num.length < 9 || num.length > 11) {
          return this.$t("pixFormatError");
        }
        return "";
      }
      // Email：清理所有空格（两端 + 中间）后校验，必须包含 @
      if (type === "EMAIL") {
        const cleaned = value.replace(/\s+/g, "");
        // 回写去除所有空格后的值，避免用户提交/展示时带空格
        if (cleaned !== value) this.pixAccount = cleaned;
        if (!cleaned.includes("@")) {
          return this.$t("pixFormatError");
        }
        return "";
      }
      // EVP：支持两种格式，满足其一即可
      if (type === "EVP") {
        // 1) 标准 UUID（8-4-4-4-12），小写十六进制字符 + 连字符
        //    ^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$
        const isUuid = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/.test(value);
        // 2) 32 位无连字符的数字/字母
        const is32 = /^[0-9a-zA-Z]{32}$/.test(value);
        if (!isUuid && !is32) {
          return this.$t("pixFormatError");
        }
        return "";
      }
      return "";
    },
    // PIX 渠道表单校验（新交互规则）
    // 返回对象 { ok, type, label }：
    //   - ok: false, type: "required", label: 第一个未填的必填项名称  → 提示 "{label}未填写"
    //   - ok: false, type: "format"                                  → 提示 "格式错误，请检查"，并标红所有错误字段
    //   - ok: true                                                  → 校验通过
    validatePixForm() {
      this.pixNameError = "";
      this.documentTypeError = "";
      this.documentIdError = "";
      this.accountTypeError = "";
      this.pixAccountError = "";
      this.whatsAppError = "";

      // ===== 第一步：必填项未填检查（按必填项顺序，提示第一个未填项） =====
      // 必填顺序：Pix username → ID type → Personal ID number → Pix account type → Pix account ID → WhatsApp ID
      const requiredList = [
        { filled: !!this.pixName, label: this.$t("withdrawalLogin.name") },
        { filled: !!this.documentType, label: this.$t("withdrawalLogin.documentType") },
        { filled: !!this.documentId, label: this.$t("withdrawalLogin.documentId") },
        { filled: !!this.accountType, label: this.$t("withdrawalLogin.accountType") },
        { filled: !!this.pixAccount, label: this.$t("withdrawalLogin.accountId") },
        { filled: !!this.whatsApp, label: "WhatsApp ID" },
      ];
      // 找出第一个未填写的必填项
      const firstEmpty = requiredList.find((item) => !item.filled);
      if (firstEmpty) {
        return { ok: false, type: "required", label: firstEmpty.label };
      }

      // ===== 第二步：字段格式校验（都填完后执行；有错则标红对应字段） =====
      // 说明：documentType / accountType 在第一步已保证非空，此处直接按所选类型校验
      // Personal ID number 按 ID type 校验（CPF 11 位 / CNPJ 14 位）
      this.documentIdError = this.validatePixDocumentId(this.documentType);
      // Pix account ID 按 account type 校验（CPF/CNPJ/PHONE/EMAIL/EVP）
      this.pixAccountError = this.validatePixAccountId();

      // 任一字段格式错误 → 提示"格式错误，请检查"，并保留各字段标红与内联提示
      if (this.documentIdError || this.pixAccountError) {
        return { ok: false, type: "format" };
      }
      return { ok: true };
    },
    // PIX 格式错误时，将页面滚动定位到第一个出错的字段并聚焦输入框
    scrollToPixError() {
      // 按表单顺序查找第一个出错的字段：证件号 → 账号
      const map = [
        { error: this.documentIdError, ref: "pixDocumentInput" },
        { error: this.pixAccountError, ref: "pixAccountInput" },
      ];
      const target = map.find((item) => !!item.error);
      if (!target) return;
      this.$nextTick(() => {
        const el = this.$refs[target.ref];
        if (!el) return;
        // 聚焦输入框（focusin 会记录 activeInput，并由共享键盘避让逻辑校准位置）
        try {
          el.focus();
        } catch (e) {
          /* 忽略聚焦异常 */
        }
        this.activeInput = el;
        this.keepActiveInputVisible();
      });
    },
    // 按当前渠道组装待提交的表单对象（供 buildBindParams 使用）
    getFormState() {
      if (this.isGpay) {
        return {
          whatsApp: this.whatsApp,
          accountName: this.gPayInfo.accountName,
          bankId: this.gPayInfo.bankId,
          iban: this.gPayInfo.iban,
          branchNumber: this.gPayInfo.branchNumber,
          accountNumber: this.gPayInfo.accountNumber,
          type: this.gPayInfo.type,
        };
      }
      if (this.isTr) {
        return {
          payeeAccount: this.payeeAccount,
          payeeName: this.payeeName,
          whatsApp: this.whatsApp,
        };
      }
      if (this.isPix) {
        // PHONE 类型账号固定带巴西国家码前缀 +55（模板中前缀为写死展示，提交时拼接完整号码）
        const account =
          this.accountType === "PHONE" && this.pixAccount
            ? "+55" + this.pixAccount
            : this.pixAccount;
        return {
          name: this.pixName,
          whatsApp: this.whatsApp,
          document_type: this.documentType,
          document_id: this.documentId,
          account_type: this.accountType,
          account: account,
        };
      }
      if (this.isIndonesiaWallet) {
        return {
          fullName: this.fullName,
          payeeAccount: this.payeeAccount,
          whatsApp: this.whatsApp,
        };
      }
      if (this.isIndonesiaBank) {
        return {
          fullName: this.fullName,
          bankId: this.bankId,
          cardNumber: this.cardNumber,
          whatsApp: this.whatsApp,
        };
      }
      if (this.isIndonesiaEwallet) {
        return {
          fullName: this.fullName,
          bankId: this.bankId,
          phoneNumber: this.phoneNumber,
          whatsApp: this.whatsApp,
        };
      }
      // 标准渠道默认表单
      return {
        account: this.account,
        payeeName: this.payeeName,
        whatsApp: this.whatsApp,
      };
    },
    // 按当前渠道类型执行对应的整体表单校验，任一字段不通过即返回 false
    validateForm() {
      this.clearFieldErrors();
      if (this.isGpay) return this.validateGpayForm();
      if (this.isTr) return this.validateTrForm();
      if (this.isPix) return this.validatePixForm();
      if (this.isIndonesiaWallet) {
        return (
          this.validateIndonesiaName() &&
          this.validateIndonesiaWalletAccount() &&
          this.validateWhatsAppDigits()
        );
      }
      if (this.isIndonesiaBank) {
        if (!this.bankId) {
          this.bankError = (this.detailsObj.select || "") + (this.detailsObj.bank || "");
          return false;
        }
        return (
          this.validateIndonesiaName() &&
          this.validateIndonesiaCardNumber() &&
          this.validateWhatsAppDigits()
        );
      }
      if (this.isIndonesiaEwallet) {
        if (!this.bankId) {
          this.bankError = (this.detailsObj.select || "") + (this.detailsObj.bank || "");
          return false;
        }
        return (
          this.validateIndonesiaName() &&
          this.validateIndonesiaPhone() &&
          this.validateWhatsAppDigits()
        );
      }
      if (!this.whatsApp) {
        this.whatsAppError = this.$t("withdrawalLogin.Whatsapp");
        return false;
      }
      return this.validateAccount();
    },
    // 汇总取第一条存在的字段错误信息用于提示
    getValidationErrorMessage() {
      return (
        this.gPayError ||
        this.bankError ||
        this.trNameError ||
        this.trAccountError ||
        this.pixNameError ||
        this.documentIdError ||
        this.pixAccountError ||
        this.fullNameError ||
        this.payeeAccountError ||
        this.cardNumberError ||
        this.phoneNumberError ||
        this.accountError ||
        this.whatsAppError ||
        ""
      );
    },
    // 绑定成功后写入 localStorage，与旧页 setLoaclStorage 字段保持一致
    persistLocalBind(id, params) {
      if (this.isPix) {
        localStorage.setItem("name", params.name);
        localStorage.setItem("id", params.whatsApp);
        localStorage.setItem("document_type", params.document_type);
        localStorage.setItem("document_id", params.document_id);
        localStorage.setItem("account_type", params.account_type);
        localStorage.setItem("account", params.account);
        return;
      }
      if (this.isIndonesiaWallet) {
        localStorage.setItem("fullName", params.payeeName);
        localStorage.setItem("payeeAccount", params.payeeAccount);
        localStorage.setItem("whatsApp", params.whatsApp);
        return;
      }
      if (this.isIndonesiaBank) {
        localStorage.setItem("fullName", params.account);
        localStorage.setItem("cardNumber", params.account_number);
        localStorage.setItem("whatsApp", params.whatsApp);
        return;
      }
      if (this.isIndonesiaEwallet) {
        localStorage.setItem("fullName", params.account);
        localStorage.setItem("phoneNumber", params.account_phone);
        localStorage.setItem("whatsApp", params.whatsApp);
        return;
      }
      // GPay / 土耳其不写 num{id}；其余渠道缓存账号
      if (!this.isGpay && !this.isTr) {
        localStorage.setItem("num" + id, params.account || params.payeeAccount);
      }
      localStorage.setItem("id", params.whatsApp);
    },
    // 提交绑定：先校验表单，再组装 params 调用 bindInfo/save 服务端保存
    submitBind() {
      // PIX 渠道走新校验交互：区分"必填未填"与"格式错误"两种 toast 提示
      if (this.isPix) {
        const pixResult = this.validatePixForm();
        if (!pixResult.ok) {
          // 有必填项未填：提示第一个未填项的 "{label}未填写"
          if (pixResult.type === "required") {
            Toast(this.$t("notFilled", { s: pixResult.label }));
            return;
          }
          // 字段格式错误：提示"格式错误，请检查"（字段已标红 + 内联提示）
          if (pixResult.type === "format") {
            Toast(this.$t("formatErrorCheck"));
            this.scrollToPixError();
            return;
          }
        }
        // 校验通过后继续走提交流程
        if (!pixResult.ok) return;
      } else if (!this.validateForm()) {
        // 其他渠道沿用旧逻辑：优先展示字段级错误文案，与旧页 inline errtxt 一致
        Toast(this.getValidationErrorMessage() || this.$t("transfer.error"));
        return;
      }
      this.submitting = true;
      const id = Number(this.itemId);
      const paramsObj = buildBindParams(id, this.getFormState());
      // 走服务端保存：bindType=1 自提现渠道，bizKey=channelId，infoJson 存渠道表单字段
      saveBindInfo({
        bindType: BIND_TYPE_WITHDRAW,
        bizKey: String(this.itemId),
        channelId: Number(this.itemId),
        info: paramsObj,
        serviceIp: this.$serviceIp,
        token: this.token,
        uid: this.uid,
        deviceId: this.deviceId,
        lang: this.lang,
      })
        .then((ok) => {
          if (ok) {
            // 成功：持久化本地缓存（兜底）并通知父组件（进入确认页）
            this.persistLocalBind(id, paramsObj);
            Toast(this.$t("transfer.bindSuccess"));
            this.$emit("bound", paramsObj);
          } else {
            Toast(this.$t("transfer.error"));
          }
        })
        .catch(() => {
          Toast(this.$t("transfer.error"));
        })
        .finally(() => {
          this.submitting = false;
        });
    },
  },
};
</script>

<style scoped>
/* —— 底部滑出/滑入过渡动画 —— */
/* 遮罩淡入淡出 */
.cbs-enter-active,
.cbs-leave-active {
  transition: opacity 0.25s ease;
}
.cbs-enter,
.cbs-leave-to {
  opacity: 0;
}

/* 面板从屏幕底部滑入 */
.cbs-enter-active .cbs-sheet,
.cbs-leave-active .cbs-sheet {
  transition: transform 0.3s ease;
}
.cbs-enter .cbs-sheet,
.cbs-leave-to .cbs-sheet {
  transform: translateY(100%);
}

.cbs-mask {
  position: fixed;
  inset: 0;
  z-index: 300;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: flex-end;
}

.cbs-sheet {
  width: 100%;
  max-height: 60vh;
  background: #fff;
  border-radius: 24px 24px 0 0;
  display: flex;
  flex-direction: column;
}

.cbs-header {
  position: relative;
  padding: 24px 32px 24px;
  text-align: center;
  flex-shrink: 0;
}

.cbs-title {
  margin: 0;
  font-size: 28px;
  font-weight: 500;
  color: #1F1315;
}

.cbs-close {
  position: absolute;
  right: 28px;
  top: 32px;
  width: 28px;
  height: 28px;
}

.cbs-close::before,
.cbs-close::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  width: 20px;
  height: 2px;
  background: #121212;
}

.cbs-close::before {
  transform: translate(-50%, -50%) rotate(45deg);
}

.cbs-close::after {
  transform: translate(-50%, -50%) rotate(-45deg);
}

.cbs-body {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overscroll-behavior: contain;
  -webkit-overflow-scrolling: touch;
  scroll-padding: 16px 0;
  padding: 0 28px 24px;
}

.cbs-field {
  margin-bottom: 20px;
}

.cbs-field label {
  display: block;
  margin-bottom: 8px;
  font-size: 24px;
  color: #89848D;
}

.cbs-field .req {
  color: #ff4365;
  font-style: normal;
  margin-left: 4px;
}

.cbs-field input,
.cbs-select,
.cbs-select-native {
  width: 100%;
  height: 80px;
  padding: 0 24px;
  border: 1px solid #DFD9E3;
  border-radius: 16px;
  font-size: 24px;
  box-sizing: border-box;
  background: #fff;
  line-height: 80px;
  display: block;
}

/* PHONE 类型账号：固定国家码前缀 +55（写死展示），与输入框组合成一行 */
.cbs-input-group {
  display: flex;
  align-items: stretch;
  width: 100%;
  height: 80px;
  border: 1px solid #DFD9E3;
  border-radius: 16px;
  background: #fff;
  box-sizing: border-box;
  overflow: hidden;
}

.cbs-input-group .cbs-prefix {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  padding: 0 20px;
  font-size: 24px;
  color: #999;
  background: #f5f5f5;
  border-right: 1px solid #DFD9E3;
}

.cbs-input-group input {
  flex: 1 1 auto;
  width: auto;
  height: 100%;
  border: none;
  border-radius: 0;
  padding: 0 24px;
}

.cbs-select-native {
  appearance: none;
  color: #262427;
}

.cbs-select {
  position: relative;
  color: #262427;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}

/* 下拉当前选中文本 */
.cbs-select-text {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* 下拉箭头（三角，默认朝下，展开朝上） */
.cbs-select-arrow {
  display: inline-block;
  width: 40px;
  height: 40px;
  background: url('../../assets/withdrawal/topage.png') no-repeat;
  background-size: 100% 100%;
}
/* .cbs-select-arrow.is-up {
  transform: rotate(180deg);
} */

/* 模拟下拉的选项浮层（复用 cbs-bank-menu 的外观） */
.cbs-option-menu {
  margin-top: 8px;
  max-height: 300px;
  overflow-y: auto;
  border: 1px solid #eee;
  border-radius: 16px;
  background: #fff;
}

.cbs-option {
  margin: 0;
  padding: 24px;
  font-size: 26px;
  line-height: 40px;
  color: #262427;
  border-bottom: 1px solid #f1f1f1;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}
.cbs-option:last-child {
  border-bottom: none;
}
/* 当前选中项高亮 */
.cbs-option.is-active {
  color: #8131E7;
  font-weight: 500;
}

.cbs-bank-menu {
  margin-top: 8px;
  max-height: 240px;
  overflow-y: auto;
  border: 1px solid #eee;
  border-radius: 16px;
  background: #fff;
}

.cbs-bank-menu input {
  height: 64px;
  border: none;
  border-bottom: 1px solid #eee;
  border-radius: 0;
}

.cbs-bank-menu p {
  margin: 0;
  padding: 20px 24px;
  font-size: 24px;
  border-bottom: 1px solid #f1f1f1;
}

.cbs-error {
  margin: 8px 0 0;
  font-size: 22px;
  color: #f46363;
}

/* PIX 校验错误：输入框与下拉标红边框 + 浅红背景 */
.cbs-field input.is-error,
.cbs-select.is-error {
  border-color: #f46363;
  background: #fff5f5;
}

.cbs-tips {
  margin-top: 4px;
  padding: 20px 24px;
  border-radius: 16px;
  font-size: 22px;
  line-height: 34px;
  color: #262427;
  background: linear-gradient(360deg, rgba(255, 147, 147, 0) 0%, rgba(255, 147, 147, 0.25) 100%);
}
.cbs-tips p {
  font-size: 24px;
  color: #262427;
}

.cbs-tips-title {
  margin: 0 0 20px!important;
  font-size: 24px;
  font-weight: 500;
  color: #ff4365;
  vertical-align: top;
}
.cbs-tips-title::before{
  display: inline-block;
  content: '';
  width: 32px;
  height: 32px;
  background: url('../../assets/withdrawal_v2/elert.png') no-repeat;
  background-size: 100% 100%;
  vertical-align: top;
  margin-right: 8px;
}

.cbs-footer {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 150px;
  flex-shrink: 0;
}

.cbs-submit {
  width: 412px;
  height: 80px;
  border: none;
  border-radius: 40px;
  background: #8131E7;
  font-size: 24px;
  font-weight: 500;
  color: #fff;
  margin: 0 auto;
}

.cbs-submit:disabled {
  opacity: 0.6;
}

.hide-scrollbar {
  scrollbar-width: none;
}

.hide-scrollbar::-webkit-scrollbar {
  display: none;
}

/* 阿语 RTL 适配（2026-06-08） */
html[lang="ar"] .cbs-sheet {
  direction: rtl;
}

html[lang="ar"] .cbs-close {
  right: auto;
  left: 28px;
}

html[lang="ar"] .cbs-field .req {
  margin-left: 0;
  margin-right: 4px;
}

html[lang="ar"] .cbs-tips-title::before {
  margin-right: 0;
  margin-left: 8px;
}

html[lang="ar"] .cbs-submit {
  width: 100%;
  max-width: 412px;
}

/* 阿语 RTL：下拉箭头翻转到左侧 */
html[lang="ar"] .cbs-select-arrow {
  margin-left: 0;
  margin-right: 12px;
}
</style>
